import React from 'react';
import { motion } from 'framer-motion';
export type ButtonVariant = 'primary' | 'outline-light' | 'outline-dark';
interface ButtonProps {
  href: string;
  children: React.ReactNode;
  variant?: ButtonVariant;
  className?: string;
  onClick?: () => void;
}
const variantClasses: Record<ButtonVariant, string> = {
  primary: 'bg-burgundy text-ivory hover:bg-burgundy-dark border border-burgundy hover:border-burgundy-dark',
  'outline-light': 'bg-transparent text-ivory border border-ivory/50 hover:border-ivory hover:bg-ivory/10',
  'outline-dark': 'bg-transparent text-ink border border-ink/30 hover:border-ink hover:bg-ink/5'
};
export function Button({
  href,
  children,
  variant = 'primary',
  className = '',
  onClick
}: ButtonProps) {
  return <motion.a href={href} onClick={onClick} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.12,
    ease: [0.22, 1, 0.36, 1]
  }} className={`inline-flex items-center justify-center whitespace-nowrap px-8 py-4 text-xs font-semibold uppercase tracking-widest2 transition-colors duration-200 ${variantClasses[variant]} ${className}`} data-id="element-40" data-mp="23909kwg8cqrx">
      {children}
    </motion.a>;
}